/*
 *--------------------------------------------------------------------------
 * Common Functions
 *--------------------------------------------------------------------------
 *
 * This file contains common functions to utilize throughout the search app.
 *
 */

const hidePlantIcons = () => {
	if (window.mivaJS?.Screen !== 'CTGY') {
		return false;
	}

	const categoryCode = window.mivaJS.Category_Code;
	const parentCategoryCode = window.mivaJS.Parent_Category?.code ?? false;

	const hideIconsCategoryCodes = [
		'books',
		'seed-mixes',
		'tools-and-gifts',
		'tool-shed'
	];

	return hideIconsCategoryCodes.some((code) => categoryCode === code || parentCategoryCode === code);
};

export {
	hidePlantIcons
};
